import React from "react";
import "./styles/brriStyle.css";
import CompassDirectionLabel from "./compass/CompassDirectionLabel";
import { generatePath } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { TbListDetails } from "react-icons/tb";

function BrriValueCard({ icon, value, unit, title, sensorId }) {
  const navigate = useNavigate();

  const detailsClickHandler = (sensorId) => {
    const path = generatePath("/detailsPage/:sensorId", {
      sensorId: sensorId,
    });
    navigate(path);
  };
  return (
    <div>
      <div className="zero-padding">
        <div
          className="card theme-background card-container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
        >
          <div>
            <div className="value-icon-container">
              <div className="brri-icon">
                {/* <img src={icon || ""}></img> */}
                {icon}
              </div>
              <div
                className="brri-card-value theme-text"
                style={{ display: "flex" }}
              >
                {value || ""}
                &nbsp;
                <span>{unit || ""}</span>
                {sensorId == "121" && (
                  <span
                    className="brri-card-value theme-text"
                    style={{ display: "inline-flex" }}
                  >
                    {"("} <CompassDirectionLabel degreeValue={value} /> {")"}
                  </span>
                )}
              </div>
            </div>
            <div className="theme-text brri-card-title">{title || ""}</div>
          </div>
          {(sensorId == "120" || sensorId == "121") && (
            <div
              className="details-text theme-text"
              onClick={() => detailsClickHandler(sensorId)}
            >
              <TbListDetails />
              details
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BrriValueCard;
